import { IconProps } from './IconProps';
export function InfoIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1340_45709)">
                <path
                    d="M12 23.001C18.0751 23.001 23 18.0761 23 12.001C23 5.92584 18.0751 1.00098 12 1.00098C5.92487 1.00098 1 5.92584 1 12.001C1 18.0761 5.92487 23.001 12 23.001Z"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 17.0049H13C12.7348 17.0049 12.4804 16.8995 12.2929 16.712C12.1054 16.5245 12 16.2701 12 16.0049V9.50488C12 9.37228 11.9473 9.2451 11.8536 9.15133C11.7598 9.05756 11.6326 9.00488 11.5 9.00488H10"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.7422 7C11.6041 7 11.4922 6.88807 11.4922 6.75C11.4922 6.61193 11.6041 6.5 11.7422 6.5"
                    stroke="#66182A"
                />
                <path
                    d="M11.7422 7C11.8802 7 11.9922 6.88807 11.9922 6.75C11.9922 6.61193 11.8802 6.5 11.7422 6.5"
                    stroke="#66182A"
                />
            </g>
            <defs>
                <clipPath id="clip0_1340_45709">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
